export const viewsByFilters = [
    'Problem Type',
    'Machine Type',
    'Machine Sub-type',
    'Machine Brand',
];